module.exports = __webpack_public_path__ + "static/media/400288_02.f2e3fba2.png";